import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style.css'
import App from './App';
import './interceptors/axios';
import { store } from './redux/store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
